// Kannada translations for breed data. Only string fields are translated;
// numeric values (₹, kg, L, %, sqft, hrs) remain identical to source data per product spec.

export const breedTranslationsKN = {
    hf: {
        name: "ಹಾಲ್‌ಸ್ಟೀನ್ ಫ್ರೀಸಿಯನ್",
        shortName: "HF",
        tagline: "ಹೆಚ್ಚು ಪ್ರಮಾಣದ ವಾಣಿಜ್ಯಿಕ ಹಾಲಿನ ಹಸು.",
        origin: "ನೆದರ್‌ಲ್ಯಾಂಡ್ಸ್ ಮತ್ತು ಉತ್ತರ ಜರ್ಮನಿ",
        classification: "ವಿದೇಶಿ ಹಾಲಿನ ತಳಿ",
        color: "ವಿಶಿಷ್ಟ ಕಪ್ಪು ಮತ್ತು ಬಿಳಿ ಚುಕ್ಕೆಗಳು",
        quickFacts: [
            { label: "ಸರಾಸರಿ ಉತ್ಪಾದನೆ", value: "20–25 L/day" },
            { label: "ಹಾಲಿನ ಕೊಬ್ಬು", value: "3.0%" },
            { label: "ಆಯಸ್ಸು", value: "6–8 ಹಾಲುಣಿಸುವಿಕೆಗಳು" },
            { label: "ಹವಾಮಾನ", value: "ತಂಪು ಆದ್ಯತೆ" },
        ],
        production: {
            lactationPeriod: "305 ದಿನಗಳು",
            suitableFor: ["ಕುಡಿಯುವ ಹಾಲು", "ಪನೀರ್", "ಮೊಸರು", "ಚೀಸ್"],
        },
        housing: {
            ventilation: "ಫ್ಯಾನ್‌ಗಳೊಂದಿಗೆ ಅಡ್ಡ ವಾಯುಪ್ರಸರಣ ಅಗತ್ಯ",
            floor: "ರಬ್ಬರ್ ಮ್ಯಾಟ್‌ಗಳೊಂದಿಗೆ ಗ್ರೂವ್ಡ್ ಕಾಂಕ್ರೀಟ್",
            drainage: "ಕೇಂದ್ರ ಚರಂಡಿಗೆ 2% ಇಳಿಜಾರು",
            bedding: "ಭತ್ತದ ಒಣಹುಲ್ಲು ಅಥವಾ ಮರಳು",
        },
        health: {
            diseaseResistance: "ಸಾಧಾರಣ — ಉಷ್ಣವಲಯದ ಒತ್ತಡಕ್ಕೆ ಸಂವೇದನೆ",
            commonDiseases: ["ಕೆಚ್ಚಲುಬಾವು", "ಹಾಲಿನ ಜ್ವರ", "ಕೀಟೋಸಿಸ್"],
            heatStress: "28°C ಗಿಂತ ಹೆಚ್ಚಿನ ಶಾಖಕ್ಕೆ ಹೆಚ್ಚಿನ ಸಂವೇದನೆ",
            tickResistance: "ಕಡಿಮೆ",
            mastitis: "ಹೆಚ್ಚಿನ ಸಂವೇದನೆ",
            veterinary: "ಮಾಸಿಕ ಪಶು ಪರೀಕ್ಷೆ ಶಿಫಾರಸು",
        },
        reproduction: {
            fertility: "ಭಾರತೀಯ ಪರಿಸ್ಥಿತಿಗಳಲ್ಲಿ ಸಾಧಾರಣ",
            insemination: "ಸೆಕ್ಸ್ಡ್ ಸೀಮನ್‌ನೊಂದಿಗೆ AI ವ್ಯಾಪಕ ಬಳಕೆ",
            natural: "ವಾಣಿಜ್ಯಿಕವಾಗಿ ಅಪರೂಪ",
        },
        environment: {
            heat: "ಕಡಿಮೆ ಸಹಿಷ್ಣುತೆ",
            rain: "ಸಾಧಾರಣ — ಆಶ್ರಯ ಅಗತ್ಯ",
            cold: "ಹೆಚ್ಚಿನ ಸಹಿಷ್ಣುತೆ",
            humidity: "ಕಡಿಮೆ ಸಹಿಷ್ಣುತೆ",
            regions: "ಚಿಕ್ಕಮಗಳೂರು, ಹಾಸನ, ಕೊಡಗು — ಕರ್ನಾಟಕದ ತಂಪಾದ ಘಾಟಿಗಳು",
        },
        business: ["ಮಧ್ಯಮ ಫಾರ್ಮ್‌ಗಳು", "ವಾಣಿಜ್ಯಿಕ ಫಾರ್ಮ್‌ಗಳು", "ಹೆಚ್ಚಿನ ಪ್ರಮಾಣದ ಡೇರಿ"],
        recommendation: {
            bestFor: "ಶೀತಲ ಸಂಗ್ರಹಣಾ ಸೌಲಭ್ಯ ಇರುವ ಕರ್ನಾಟಕದ ತಂಪಾದ ಪ್ರದೇಶಗಳಲ್ಲಿನ ದೊಡ್ಡ ಪ್ರಮಾಣದ ವಾಣಿಜ್ಯಿಕ ಡೇರಿಗಳಿಗೆ.",
            notFor: "ಸಣ್ಣ ಹಿತ್ತಲಿನ ರೈತರು, ತೇವಾಂಶಭರಿತ ಕರಾವಳಿ ಬೆಲ್ಟ್‌ಗಳು ಮತ್ತು ಕಡಿಮೆ-ಇನ್‌ಪುಟ್ ಕಾರ್ಯಾಚರಣೆಗಳಿಗೆ ಅಲ್ಲ.",
            expectedROI: "24 – 30 ತಿಂಗಳು (ಸಂಘಟಿತ ಮಾರುಕಟ್ಟೆಯೊಂದಿಗೆ)",
            advantages: [
                "ಎಲ್ಲಾ ತಳಿಗಳಲ್ಲಿ ಅತಿ ಹೆಚ್ಚು ದೈನಂದಿನ ಉತ್ಪಾದನೆ",
                "ಊಹಿಸಬಹುದಾದ ಉತ್ಪಾದನಾ ರೇಖೆ",
                "ಚೆನ್ನಾಗಿ ದಾಖಲಿತ ನಿರ್ವಹಣಾ ಪ್ರೋಟೋಕಾಲ್‌ಗಳು",
            ],
            challenges: [
                "ಶಾಖ ಸಂವೇದನೆ — ತಂಪಾಗಿಸುವ ಸೌಕರ್ಯ ಅಗತ್ಯ",
                "ಹೆಚ್ಚಿನ ಪಶು ವೈದ್ಯಕೀಯ ಮತ್ತು ಆಹಾರದ ವೆಚ್ಚ",
                "ಶಿಸ್ತುಬದ್ಧ ನಿರ್ವಹಣೆ ಅಗತ್ಯ",
            ],
        },
    },
    jersey: {
        name: "ಜರ್ಸಿ",
        shortName: "ಜರ್ಸಿ",
        tagline: "ಶ್ರೀಮಂತ, ಬೆಣ್ಣೆಯಂತಹ ಹಾಲು — ಗುಣಗ್ರಾಹಿಗಳ ಹಸು.",
        origin: "ಜರ್ಸಿ ದ್ವೀಪ, ಇಂಗ್ಲಿಷ್ ಚಾನಲ್",
        classification: "ವಿದೇಶಿ ಹಾಲಿನ ತಳಿ",
        color: "ತಿಳಿ ಕಂದು ಬಣ್ಣದಿಂದ ಗಾಢ ಕಂದು ಬಿಳಿ ಚುಕ್ಕೆಗಳೊಂದಿಗೆ",
        quickFacts: [
            { label: "ಸರಾಸರಿ ಉತ್ಪಾದನೆ", value: "12–15 L/day" },
            { label: "ಹಾಲಿನ ಕೊಬ್ಬು", value: "3.5%" },
            { label: "ಆಯಸ್ಸು", value: "7–9 ಹಾಲುಣಿಸುವಿಕೆಗಳು" },
            { label: "ಹವಾಮಾನ", value: "ಹೊಂದಿಕೊಳ್ಳುವ" },
        ],
        production: {
            lactationPeriod: "305 ದಿನಗಳು",
            suitableFor: ["ತುಪ್ಪ", "ಬೆಣ್ಣೆ", "ಪನೀರ್", "ಮೊಸರು", "ಚೀಸ್"],
        },
        housing: {
            ventilation: "ಸ್ವಾಭಾವಿಕ ಅಡ್ಡ ವಾಯುಪ್ರಸರಣ ಸಾಕು",
            floor: "ರಬ್ಬರ್ ಮ್ಯಾಟ್‌ಗಳೊಂದಿಗೆ ಗ್ರೂವ್ಡ್ ಕಾಂಕ್ರೀಟ್",
            drainage: "ಕೇಂದ್ರ ಚರಂಡಿಗೆ 2% ಇಳಿಜಾರು",
            bedding: "ಭತ್ತದ ಒಣಹುಲ್ಲು",
        },
        health: {
            diseaseResistance: "ಉಷ್ಣವಲಯ ಪರಿಸ್ಥಿತಿಗಳಲ್ಲಿ HF ಗಿಂತ ಉತ್ತಮ",
            commonDiseases: ["ಕೆಚ್ಚಲುಬಾವು", "ಹಾಲಿನ ಜ್ವರ"],
            heatStress: "ಸಾಧಾರಣ — 32°C ವರೆಗೆ ಆರಾಮ",
            tickResistance: "ಸಾಧಾರಣ",
            mastitis: "ಸಾಧಾರಣ ಸಂವೇದನೆ",
            veterinary: "ಎರಡು ತಿಂಗಳಿಗೊಮ್ಮೆ ಪಶು ಪರೀಕ್ಷೆ",
        },
        reproduction: {
            fertility: "ಉತ್ತಮ",
            insemination: "AI ಆದ್ಯತೆ",
            natural: "ಸಣ್ಣ ಫಾರ್ಮ್‌ಗಳಲ್ಲಿ ಬಳಕೆ",
        },
        environment: {
            heat: "ಸಾಧಾರಣ ಸಹಿಷ್ಣುತೆ",
            rain: "ಉತ್ತಮ ಸಹಿಷ್ಣುತೆ",
            cold: "ಹೆಚ್ಚಿನ ಸಹಿಷ್ಣುತೆ",
            humidity: "ಸಾಧಾರಣ ಸಹಿಷ್ಣುತೆ",
            regions: "ಮೈಸೂರು, ಮಂಡ್ಯ, ತುಮಕೂರು, ಕೋಲಾರ — ಕರ್ನಾಟಕದ ಬಹುತೇಕ ಪ್ರಸ್ಥಭೂಮಿ",
        },
        business: ["ಸಣ್ಣ ಫಾರ್ಮ್‌ಗಳು", "ಮಧ್ಯಮ ಫಾರ್ಮ್‌ಗಳು", "ವಾಣಿಜ್ಯಿಕ ಫಾರ್ಮ್‌ಗಳು", "ಸಾವಯವ ಡೇರಿ"],
        recommendation: {
            bestFor: "ಕರ್ನಾಟಕದಾದ್ಯಂತ ತುಪ್ಪ, ಪನೀರ್ ಮತ್ತು ಪ್ರೀಮಿಯಂ ಹಾಲಿನ ಮಾರುಕಟ್ಟೆಗಳನ್ನು ಗುರಿಯಾಗಿಸಿಕೊಂಡ ರೈತರಿಗೆ.",
            notFor: "ಕೇವಲ ಪ್ರಮಾಣ ಆಧಾರಿತ ದ್ರವ ಹಾಲಿನ ಒಪ್ಪಂದಗಳಿಗಾಗಿ ಉತ್ಪಾದನೆ ಮಾಡುವ ಫಾರ್ಮ್‌ಗಳಿಗಲ್ಲ.",
            expectedROI: "20 – 26 ತಿಂಗಳು",
            advantages: [
                "ಸಾಮಾನ್ಯ ಹಾಲಿನ ತಳಿಗಳಲ್ಲಿ ಅತಿ ಹೆಚ್ಚು ಕೊಬ್ಬು ಮತ್ತು SNF",
                "ಕರ್ನಾಟಕ ಹವಾಮಾನಕ್ಕೆ ಹೊಂದಿಕೊಳ್ಳುವ",
                "ಅತ್ಯುತ್ತಮ ಆಹಾರ ಪರಿವರ್ತನಾ ದಕ್ಷತೆ",
            ],
            challenges: [
                "HF ಗಿಂತ ಕಡಿಮೆ ಒಟ್ಟು ಪ್ರಮಾಣ",
                "ಸಣ್ಣ ದೇಹ — ಕರುಪ್ರಸವದ ಸಮಯದಲ್ಲಿ ಜಾಗ್ರತೆ",
                "ಸ್ಥಳೀಯವಾಗಿ ಹಾಲಿನ ಕೊಬ್ಬಿನ ಬೆಲೆ ಸಿಗಬೇಕು",
            ],
        },
    },
    "all-black": {
        name: "ಆಲ್ ಬ್ಲ್ಯಾಕ್",
        shortName: "ಆಲ್ ಬ್ಲ್ಯಾಕ್",
        tagline: "ಬಲಿಷ್ಠ ಸಂಕರ ಶುದ್ಧ ಕಪ್ಪು ಹಸುಗಳು.",
        origin: "ಆಯ್ಕೆ ಆಧಾರಿತ ಭಾರತೀಯ ಸಂಕರ ತಳಿ ಕಾರ್ಯಕ್ರಮಗಳು",
        classification: "ಸಂಕರ ತಳಿ (HF × ಸ್ಥಳೀಯ)",
        color: "ಘನ ಹೊಳಪಿನ ಕಪ್ಪು",
        quickFacts: [
            { label: "ಸರಾಸರಿ ಉತ್ಪಾದನೆ", value: "12–15 L/day" },
            { label: "ಹಾಲಿನ ಕೊಬ್ಬು", value: "3.5%" },
            { label: "ಆಯಸ್ಸು", value: "6–8 ಹಾಲುಣಿಸುವಿಕೆಗಳು" },
            { label: "ಹವಾಮಾನ", value: "ಉಷ್ಣವಲಯಕ್ಕೆ ಹೊಂದಿಕೊಂಡ" },
        ],
        production: {
            lactationPeriod: "300 ದಿನಗಳು",
            suitableFor: ["ಕುಡಿಯುವ ಹಾಲು", "ಪನೀರ್", "ಮೊಸರು", "ತುಪ್ಪ"],
        },
        housing: {
            ventilation: "ಫ್ಯಾನ್‌ಗಳೊಂದಿಗೆ ಅಡ್ಡ ವಾಯುಪ್ರಸರಣ",
            floor: "ರಬ್ಬರ್ ಮ್ಯಾಟ್‌ಗಳೊಂದಿಗೆ ಗ್ರೂವ್ಡ್ ಕಾಂಕ್ರೀಟ್",
            drainage: "ಕೇಂದ್ರ ಚರಂಡಿಗೆ 2% ಇಳಿಜಾರು",
            bedding: "ಭತ್ತದ ಒಣಹುಲ್ಲು",
        },
        health: {
            diseaseResistance: "ಶುದ್ಧ HF ಗಿಂತ ಉತ್ತಮ",
            commonDiseases: ["ಕೆಚ್ಚಲುಬಾವು", "ಹಾಲಿನ ಜ್ವರ"],
            heatStress: "ಸಾಧಾರಣ — ನೆರಳು ಮತ್ತು ಫ್ಯಾನ್ ಅಗತ್ಯ",
            tickResistance: "ಸಾಧಾರಣ",
            mastitis: "ಸಾಧಾರಣ ಸಂವೇದನೆ",
            veterinary: "ಮಾಸಿಕ ಪಶು ಪರೀಕ್ಷೆ",
        },
        reproduction: {
            fertility: "ಉತ್ತಮ",
            insemination: "AI ವ್ಯಾಪಕ ಬಳಕೆ",
            natural: "ಕೆಲವೊಮ್ಮೆ ಬಳಕೆ",
        },
        environment: {
            heat: "ಸಾಧಾರಣ ಸಹಿಷ್ಣುತೆ",
            rain: "ಉತ್ತಮ ಸಹಿಷ್ಣುತೆ",
            cold: "ಹೆಚ್ಚಿನ ಸಹಿಷ್ಣುತೆ",
            humidity: "ಸಾಧಾರಣ ಸಹಿಷ್ಣುತೆ",
            regions: "ಬೆಂಗಳೂರು ಗ್ರಾಮಾಂತರ, ಕೋಲಾರ, ಚಿಕ್ಕಬಳ್ಳಾಪುರ, ರಾಮನಗರ",
        },
        business: ["ಮಧ್ಯಮ ಫಾರ್ಮ್‌ಗಳು", "ವಾಣಿಜ್ಯಿಕ ಫಾರ್ಮ್‌ಗಳು", "ಹೆಚ್ಚಿನ ಪ್ರಮಾಣದ ಡೇರಿ"],
        recommendation: {
            bestFor: "HF ಪ್ರಮಾಣ ಮತ್ತು ಸುಧಾರಿತ ಭಾರತೀಯ ಉಷ್ಣವಲಯ ಸಹಿಷ್ಣುತೆಯ ಸಮತೋಲನ ಬಯಸುವ ರೈತರಿಗೆ.",
            notFor: "ಸೀಮಿತ ಮೇವಿನ ಸಂಪನ್ಮೂಲಗಳ ಸಣ್ಣ ಫಾರ್ಮ್‌ಗಳಿಗಲ್ಲ.",
            expectedROI: "22 – 28 ತಿಂಗಳು",
            advantages: [
                "ಸ್ಥಳೀಯ ತಳಿಗಳಿಗಿಂತ ಹೆಚ್ಚಿನ ಉತ್ಪಾದನೆ",
                "ಶುದ್ಧ HF ಗಿಂತ ಉತ್ತಮ ಶಾಖ ಸಹಿಷ್ಣುತೆ",
                "ಸ್ಥಿರ ಮಾರುಕಟ್ಟೆ ಬೇಡಿಕೆ",
            ],
            challenges: [
                "ಸಂಕರ ತಳಿಗಳ ವ್ಯತ್ಯಾಸ",
                "ಖರೀದಿಯ ಸಮಯದಲ್ಲಿ ಜಾಗ್ರತೆಯ ಜೀನ್ ಆಯ್ಕೆ",
                "ಸಾಧಾರಣ ಮೂಲಸೌಕರ್ಯ ಹೂಡಿಕೆ",
            ],
        },
    },
    gir: {
        name: "ಗಿರ್",
        shortName: "ಗಿರ್",
        tagline: "A2 ಹಾಲಿಗೆ ಪ್ರಸಿದ್ಧ ಗಂಭೀರ ಸ್ಥಳೀಯ ತಳಿ.",
        origin: "ಗುಜರಾತ್‌ನ ಗಿರ್ ಕಾಡುಗಳು, ಭಾರತ",
        classification: "ಸ್ಥಳೀಯ (ಬಾಸ್ ಇಂಡಿಕಸ್)",
        color: "ಬಿಳಿ ಚುಕ್ಕೆಗಳೊಂದಿಗೆ ಕೆಂಪು-ಕಂದು; ವಿಶಿಷ್ಟ ಗುಂಬಜ ಆಕಾರದ ಹಣೆ",
        quickFacts: [
            { label: "ಸರಾಸರಿ ಉತ್ಪಾದನೆ", value: "8–10 L/day" },
            { label: "ಹಾಲಿನ ಕೊಬ್ಬು", value: "4.5%" },
            { label: "ಆಯಸ್ಸು", value: "10–12 ಹಾಲುಣಿಸುವಿಕೆಗಳು" },
            { label: "ಹಾಲಿನ ಪ್ರಕಾರ", value: "A2" },
        ],
        production: {
            lactationPeriod: "310 ದಿನಗಳು",
            suitableFor: ["A2 ಹಾಲು", "ತುಪ್ಪ", "ಬೆಣ್ಣೆ", "ಮೊಸರು", "ಆಯುರ್ವೇದ ಉತ್ಪನ್ನಗಳು"],
        },
        housing: {
            ventilation: "ಸ್ವಾಭಾವಿಕ ವಾಯುಪ್ರಸರಣ ಸಾಕು",
            floor: "ಗಟ್ಟಿಗೊಳಿಸಿದ ಮಣ್ಣು ಅಥವಾ ಗ್ರೂವ್ಡ್ ಕಾಂಕ್ರೀಟ್",
            drainage: "ಕೇಂದ್ರ ಚರಂಡಿಗೆ 2% ಇಳಿಜಾರು",
            bedding: "ಭತ್ತದ ಒಣಹುಲ್ಲು ಅಥವಾ ಒಣ ಎಲೆಗಳು",
        },
        health: {
            diseaseResistance: "ಅತ್ಯುತ್ತಮ — ಹೆಚ್ಚು ರೋಗ ನಿರೋಧಕ",
            commonDiseases: ["ಕೆಲವೊಮ್ಮೆ FMD", "ಅಪರೂಪದ ಕೆಚ್ಚಲುಬಾವು"],
            heatStress: "ಬಹಳ ಹೆಚ್ಚಿನ ಸಹಿಷ್ಣುತೆ",
            tickResistance: "ಅತ್ಯುತ್ತಮ",
            mastitis: "ಬಹಳ ಕಡಿಮೆ ಸಂವೇದನೆ",
            veterinary: "ತ್ರೈಮಾಸಿಕ ಪಶು ಪರೀಕ್ಷೆ",
        },
        reproduction: {
            fertility: "ಉತ್ತಮ",
            insemination: "AI ಲಭ್ಯ; ಸಹಜ ಸಾಮಾನ್ಯ",
            natural: "ವ್ಯಾಪಕ ಬಳಕೆ",
        },
        environment: {
            heat: "ಅತ್ಯುತ್ತಮ ಸಹಿಷ್ಣುತೆ",
            rain: "ಅತ್ಯುತ್ತಮ ಸಹಿಷ್ಣುತೆ",
            cold: "ಸಾಧಾರಣ ಸಹಿಷ್ಣುತೆ",
            humidity: "ಅತ್ಯುತ್ತಮ ಸಹಿಷ್ಣುತೆ",
            regions: "ಎಲ್ಲಾ ಕರ್ನಾಟಕ — ವಿಶೇಷವಾಗಿ ಬಾಗಲಕೋಟೆ, ವಿಜಯಪುರ, ರಾಯಚೂರು, ಕಲಬುರಗಿ",
        },
        business: ["ಸಣ್ಣ ಫಾರ್ಮ್‌ಗಳು", "ಮಧ್ಯಮ ಫಾರ್ಮ್‌ಗಳು", "ಸಾವಯವ ಡೇರಿ", "ಪ್ರೀಮಿಯಂ A2 ಡೇರಿ"],
        recommendation: {
            bestFor: "ಕರ್ನಾಟಕದಾದ್ಯಂತ ಪ್ರೀಮಿಯಂ A2 ಡೇರಿ, ತುಪ್ಪ ಬ್ರಾಂಡ್‌ಗಳು, ಸಾವಯವ ಮತ್ತು ಕಡಿಮೆ-ಇನ್‌ಪುಟ್ ಫಾರ್ಮ್‌ಗಳಿಗೆ.",
            notFor: "ಶುದ್ಧ ಪ್ರಮಾಣ ಆಧಾರಿತ ದ್ರವ ಹಾಲಿನ ಒಪ್ಪಂದಗಳ ಫಾರ್ಮ್‌ಗಳಿಗಲ್ಲ.",
            expectedROI: "24 – 32 ತಿಂಗಳು (ಪ್ರತಿ ಲೀಟರ್‌ಗೆ ಹೆಚ್ಚಿನ ಲಾಭಾಂಶ)",
            advantages: [
                "ಪ್ರೀಮಿಯಂ ಬೆಲೆಯ ಪ್ರಸಿದ್ಧ A2 ಹಾಲು",
                "ಅಸಾಧಾರಣ ಶಾಖ ಮತ್ತು ರೋಗ ಸಹಿಷ್ಣುತೆ",
                "ದೀರ್ಘ ಉತ್ಪಾದಕ ಜೀವನ — 10+ ಹಾಲುಣಿಸುವಿಕೆಗಳು",
            ],
            challenges: [
                "ಕಡಿಮೆ ಒಟ್ಟು ಪ್ರಮಾಣ",
                "ಮೊದಲ ಕರುವಿನ ಸಮಯದಲ್ಲಿ ಹೆಚ್ಚಿನ ವಯಸ್ಸು",
                "A2 ಅಥವಾ ಪ್ರೀಮಿಯಂ ಮಾರುಕಟ್ಟೆಯ ಪ್ರವೇಶ ಅಗತ್ಯ",
            ],
        },
    },
    kankrej: {
        name: "ಕಾಂಕ್ರೇಜ್",
        shortName: "ಕಾಂಕ್ರೇಜ್",
        tagline: "ಒಣಪ್ರದೇಶದ ಬೆಳ್ಳಿ-ಬೂದು ದ್ವಿ-ಉದ್ದೇಶ ತಳಿ.",
        origin: "ಕಚ್ ಪ್ರದೇಶ, ಗುಜರಾತ್ ಮತ್ತು ರಾಜಸ್ಥಾನ",
        classification: "ಸ್ಥಳೀಯ — ದ್ವಿ-ಉದ್ದೇಶ (ಬಾಸ್ ಇಂಡಿಕಸ್)",
        color: "ಗಾಢ ಬಿಂದುಗಳೊಂದಿಗೆ ಬೆಳ್ಳಿ-ಬೂದು ಬಣ್ಣದಿಂದ ಕಬ್ಬಿಣ-ಬೂದು",
        quickFacts: [
            { label: "ಸರಾಸರಿ ಉತ್ಪಾದನೆ", value: "8–10 L/day" },
            { label: "ಹಾಲಿನ ಕೊಬ್ಬು", value: "4.2%" },
            { label: "ಉದ್ದೇಶ", value: "ಹಾಲು + ದುಡಿಮೆ" },
            { label: "ಹವಾಮಾನ", value: "ಒಣಪ್ರದೇಶ" },
        ],
        production: {
            lactationPeriod: "300 ದಿನಗಳು",
            suitableFor: ["ಕುಡಿಯುವ ಹಾಲು", "ತುಪ್ಪ", "ಮೊಸರು"],
        },
        housing: {
            ventilation: "ಸ್ವಾಭಾವಿಕ ವಾಯುಪ್ರಸರಣ ಸಾಕು",
            floor: "ಗಟ್ಟಿಗೊಳಿಸಿದ ಮಣ್ಣು ಅಥವಾ ಗ್ರೂವ್ಡ್ ಕಾಂಕ್ರೀಟ್",
            drainage: "ಕೇಂದ್ರ ಚರಂಡಿಗೆ 2% ಇಳಿಜಾರು",
            bedding: "ಒಣ ಒಣಹುಲ್ಲು",
        },
        health: {
            diseaseResistance: "ಅತ್ಯುತ್ತಮ",
            commonDiseases: ["FMD ಅಪರೂಪದ ಸಂಭವ"],
            heatStress: "ಅತ್ಯುತ್ತಮ ಸಹಿಷ್ಣುತೆ",
            tickResistance: "ಅತ್ಯುತ್ತಮ",
            mastitis: "ಬಹಳ ಕಡಿಮೆ ಸಂವೇದನೆ",
            veterinary: "ತ್ರೈಮಾಸಿಕ ಪಶು ಪರೀಕ್ಷೆ",
        },
        reproduction: {
            fertility: "ನೈಸರ್ಗಿಕ ಪರಿಸ್ಥಿತಿಗಳಲ್ಲಿ ಉತ್ತಮ",
            insemination: "AI ಲಭ್ಯ",
            natural: "ಗ್ರಾಮೀಣ ವ್ಯವಸ್ಥೆಗಳಲ್ಲಿ ಸಾಮಾನ್ಯ",
        },
        environment: {
            heat: "ಅತ್ಯುತ್ತಮ ಸಹಿಷ್ಣುತೆ",
            rain: "ಉತ್ತಮ ಸಹಿಷ್ಣುತೆ",
            cold: "ಸಾಧಾರಣ ಸಹಿಷ್ಣುತೆ",
            humidity: "ಉತ್ತಮ ಸಹಿಷ್ಣುತೆ",
            regions: "ಉತ್ತರ ಕರ್ನಾಟಕ — ಬಾಗಲಕೋಟೆ, ವಿಜಯಪುರ, ರಾಯಚೂರು, ಬಳ್ಳಾರಿ",
        },
        business: ["ಸಣ್ಣ ಫಾರ್ಮ್‌ಗಳು", "ದ್ವಿ-ಉದ್ದೇಶ ಫಾರ್ಮ್‌ಗಳು", "ಸಾವಯವ ಡೇರಿ"],
        recommendation: {
            bestFor: "ಗಟ್ಟಿಮುಟ್ಟಾದ ದ್ವಿ-ಉದ್ದೇಶ ಪ್ರಾಣಿ ಬಯಸುವ ಅರೆ-ಒಣ ಉತ್ತರ ಕರ್ನಾಟಕದ ಫಾರ್ಮ್‌ಗಳಿಗೆ.",
            notFor: "ಪರಿಮಾಣ-ಕೇಂದ್ರಿತ ನಗರ ಡೇರಿಗಳಿಗಲ್ಲ.",
            expectedROI: "26 – 34 ತಿಂಗಳು",
            advantages: [
                "ಬಹಳ ಗಟ್ಟಿ — ಕಡಿಮೆ ಇನ್‌ಪುಟ್‌ಗಳಲ್ಲಿ ಬೆಳೆಯುತ್ತದೆ",
                "ದ್ವಿ-ಉದ್ದೇಶ ಆದಾಯ (ಹಾಲು + ದುಡಿಮೆ)",
                "ಬಹಳ ಕಡಿಮೆ ಪಶು ವೈದ್ಯಕೀಯ ವೆಚ್ಚ",
            ],
            challenges: [
                "ಕಡಿಮೆ ದೈನಂದಿನ ಉತ್ಪಾದನೆ",
                "ದೀರ್ಘ ಕರುವಿನ ಅಂತರ",
                "ಸೀಮಿತ ಹೆಚ್ಚು-ಉತ್ಪಾದನೆಯ ಜೀನ್‌ಗಳು",
            ],
        },
    },
    hallikar: {
        name: "ಹಳ್ಳಿಕಾರ್",
        shortName: "ಹಳ್ಳಿಕಾರ್",
        tagline: "ಕರ್ನಾಟಕದ ಸ್ಥಳೀಯ ಪಾರಂಪರಿಕ ದುಡಿಮೆಯ ಮತ್ತು ಮನೆ ಹಾಲಿನ ಹಸು.",
        origin: "ಹಳೆಯ ಮೈಸೂರು ಪ್ರದೇಶ, ಕರ್ನಾಟಕ",
        classification: "ಸ್ಥಳೀಯ — ಪ್ರಾಥಮಿಕವಾಗಿ ದುಡಿಮೆ, ಸಾಧಾರಣ ಹಾಲು",
        color: "ಬೂದು ಬಣ್ಣದಿಂದ ಗಾಢ ಬೂದು, ವಿಶಿಷ್ಟ ಹಣೆಯೊಂದಿಗೆ",
        quickFacts: [
            { label: "ಸರಾಸರಿ ಉತ್ಪಾದನೆ", value: "3–5 L/day" },
            { label: "ಹಾಲಿನ ಕೊಬ್ಬು", value: "4.5%" },
            { label: "ಉದ್ದೇಶ", value: "ದುಡಿಮೆ + ಹಾಲು" },
            { label: "ಪರಂಪರೆ", value: "ಕರ್ನಾಟಕ ಸ್ಥಳೀಯ" },
        ],
        production: {
            lactationPeriod: "270 ದಿನಗಳು",
            suitableFor: ["ಮನೆಯ ಹಾಲು", "ತುಪ್ಪ", "ಸಾಂಸ್ಕೃತಿಕ ಮತ್ತು ಆಚಾರಗಳ ಬಳಕೆ"],
        },
        housing: {
            ventilation: "ಸ್ವಾಭಾವಿಕ ವಾಯುಪ್ರಸರಣ ಸಾಕು",
            floor: "ಗಟ್ಟಿಗೊಳಿಸಿದ ಮಣ್ಣು ಸ್ವೀಕಾರಾರ್ಹ",
            drainage: "ಸರಳ ಗುರುತ್ವಾಕರ್ಷಣೆ ಒಳಚರಂಡಿ",
            bedding: "ಒಣ ಎಲೆಗಳು ಅಥವಾ ಒಣಹುಲ್ಲು",
        },
        health: {
            diseaseResistance: "ಅತ್ಯುತ್ತಮ",
            commonDiseases: ["ಬಹಳ ಅಪರೂಪದ FMD"],
            heatStress: "ಅತ್ಯುತ್ತಮ ಸಹಿಷ್ಣುತೆ",
            tickResistance: "ಅತ್ಯುತ್ತಮ",
            mastitis: "ಅತ್ಯಂತ ಕಡಿಮೆ ಸಂವೇದನೆ",
            veterinary: "ಅರ್ಧ-ವಾರ್ಷಿಕ ಪಶು ಪರೀಕ್ಷೆ",
        },
        reproduction: {
            fertility: "ನೈಸರ್ಗಿಕ ವ್ಯವಸ್ಥೆಗಳಲ್ಲಿ ಉತ್ತಮ",
            insemination: "ಸೀಮಿತ AI ಲಭ್ಯತೆ",
            natural: "ಪ್ರಧಾನ",
        },
        environment: {
            heat: "ಅತ್ಯುತ್ತಮ ಸಹಿಷ್ಣುತೆ",
            rain: "ಅತ್ಯುತ್ತಮ ಸಹಿಷ್ಣುತೆ",
            cold: "ಉತ್ತಮ ಸಹಿಷ್ಣುತೆ",
            humidity: "ಅತ್ಯುತ್ತಮ ಸಹಿಷ್ಣುತೆ",
            regions: "ಮೈಸೂರು, ಮಂಡ್ಯ, ಹಾಸನ, ಚಾಮರಾಜನಗರ — ಇದರ ಸ್ಥಳೀಯ ಪ್ರದೇಶ",
        },
        business: ["ಸಣ್ಣ ಫಾರ್ಮ್‌ಗಳು", "ಪರಂಪರೆ ಮತ್ತು ಸಂರಕ್ಷಣಾ ಫಾರ್ಮ್‌ಗಳು", "ಸಾಂಸ್ಕೃತಿಕ ಡೇರಿ"],
        recommendation: {
            bestFor: "ಪರಂಪರೆ ಸಂರಕ್ಷಣೆ, ಸಾಂಸ್ಕೃತಿಕ ಕೃಷಿ, ಮನೆ ಡೇರಿ ಮತ್ತು ಸಾವಯವ ಗೃಹಸ್ಥಾಶ್ರಮಗಳಿಗೆ.",
            notFor: "ವಾಣಿಜ್ಯಿಕ ಹಾಲು-ಕೇಂದ್ರಿತ ಡೇರಿಗಳಿಗಲ್ಲ.",
            expectedROI: "ಇದು ಪ್ರಾಥಮಿಕವಾಗಿ ವಾಣಿಜ್ಯಿಕ ROI ತಳಿಯಲ್ಲ",
            advantages: [
                "ಸ್ಥಳೀಯ ಕರ್ನಾಟಕ ಪರಂಪರೆ",
                "ಬಹಳ ಕಡಿಮೆ ಇನ್‌ಪುಟ್ ಅಗತ್ಯತೆಗಳು",
                "ಬಹಳ ದೀರ್ಘ ಉತ್ಪಾದಕ ಜೀವನ",
            ],
            challenges: [
                "ಬಹಳ ಕಡಿಮೆ ಹಾಲಿನ ಉತ್ಪಾದನೆ",
                "ಹೆಚ್ಚುವರಿ ಹಾಲಿಗೆ ಸೀಮಿತ ಮಾರುಕಟ್ಟೆ",
                "ಪ್ರಾಥಮಿಕವಾಗಿ ಸಾಂಸ್ಕೃತಿಕ/ಪಾರಂಪರಿಕ ಗುರಿಗಳಿಗೆ ಸೂಕ್ತ",
            ],
        },
    },
};

// English breed narrative overrides for consistency with the master data file
export const breedTranslationsEN = {};
